module.exports = __webpack_public_path__ + "img/border-left.f7007ad3.svg";